module.exports = __webpack_public_path__ + "static/media/RSwitch_Logo.477f887a.jpg";